"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(template) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return template.replace(/:[a-z|A-Z]+/g, function (match) {
    var matchedParam = match.substr(1);
    var value = params[matchedParam];

    if (typeof value === "undefined") {
      throw new Error("Matched param \"".concat(matchedParam, "\" is not presented at given object"));
    }

    return value.toString();
  });
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-server-middleware/lib/utils/replaceParams.js
// module id = 1213
// module chunks = 0